/**
 * Which registrations the Seedings list shows. A withdrawn registrant is not
 * seeded and not playing, so the list drops them. Team labels are NOT built
 * from this list: `buildTeamEntryMap` keeps the unfiltered registrants (a
 * withdrawn player can still sit in standings or a bracket slot and needs
 * their team name there).
 *
 * Shared by the public draw viewer (`DrawViewClient.transformToSeedings`) and
 * the app wire (`projectDrawDetail`), so the two cannot drift.
 */
export function activeSeedingRegistrants<R extends { status?: string | null }>(
  registrants: R[],
): R[] {
  return registrants.filter((r) => r.status !== 'withdrawn');
}
